/* tslint:disable variable-name */

import { Utils } from './cals.utils';
import { SiteRoot } from './desertland.init';
import { App } from './desertland.app';
import { TemplateLoader } from './desertland.templateLoader';
import { ROUTES } from './desertland.router';
import 'kendo-ui-core';
// import 'kendo-ui-core/js/kendo.binder';
// import 'kendo-ui-core/js/kendo.template';
// import 'kendo-ui-core/js/kendo.mobile.drawer';
// import 'kendo-ui-core/js/kendo.mobile.listview';
// import 'kendo-ui-core/js/kendo.mobile.scroller';

declare var log, info, warn, groupCollapsed, groupEnd, time, timeEnd;

/*
Template Callbacks
    data = {
        path: "templates/drawer-right.tmpl.htm", 
        tag: "tpl-drawer-right", 
        sel: drawers_sel,
        config: {
            // config object
            emptySelectorFirst : false // append
        },
        data: {
            // dynamic data
            callback: App.initRightDrawer
        }
    };
*/
const callbacks = {
  topnavReady(data) {
    //log("tpl callback - topnav");
    $("body").addClass("fixed-navbar");
    // App.currentPage implemented in template data
    //{model:App.models.pageView}
    log('%ctopnav callback > bind pageView & radio %O', "color:#666666;", data);
    kendo.bind(data.sel, App.models.pageView.viewModel);
    if ($(".topnav-item-tips").length) {
      $(".topnav-item-tips").off("click").on("click", function (e) {
        App.radio.publish('topnav:click:tips');
      });
    }
    if ($(".topnav-item-learnmore").length) {
      $(".topnav-item-learnmore").off("click").on("click", function (e) {
        App.radio.publish('topnav:click:learnmore');
      });
    }
  },
  footerReady(data) {
    // log("tpl callback - footer");
    // any js for footer, it's now available in the DOM
    // if (data.sel) {
    //     kendo.bind(data.sel, App.models.pageView);
    // } else {
    //     info("footerReady > no data.sel",data);
    // }
    App.radio.publish('tpl:footer:ready');
  },
  rightDrawerReady(data) {
    log("tpl callback - rightdrawer > init kui, bind pageView");
    //log(data);

    let $drawer = $("#drawer");
    let contentContainer_sel = $("#content-container"); // changed this oct 2018 due to @types/kendo-ui in container, below
    if ($drawer.length && $(contentContainer_sel).length) {

      // http://docs.telerik.com/kendo-ui/api/javascript/mobile/ui/drawer#configuration-container
      $drawer.kendoMobileDrawer({
        container: contentContainer_sel,
        position: 'right',
        swipeToOpen: false
      });

      $("#drawer-menu-touch-scroller").kendoMobileScroller();
      $("#drawer-menu").kendoMobileListView();

      $("#hamburger").click(function () {
        // console.log("TEST visible", $drawer.data("kendoMobileDrawer"));
        if (($drawer.data("kendoMobileDrawer") as any).visible) { // tslint complaining not found prop?
          $drawer.data("kendoMobileDrawer").hide();
        } else {
          $drawer.data("kendoMobileDrawer").show();
        }
        return false;
      });
      $drawer.find(".close").click(function () {
        $drawer.data("kendoMobileDrawer").hide();
        return false;
      });


      let $drawerLinks = $("#drawer-menu > li > a");
      if ($drawerLinks.length) {
        // not used
        $drawerLinks.click(function () {
          $drawer.data("kendoMobileDrawer").hide();
          // $(".drawer-link").removeClass("active");
          // $(this).addClass("active");
          //return false;
        });

        // $(".drawer-link").click(function(){
        //     $(".inner-content").hide();
        //     $("#" + $(this).data("target")).show();
        // });
      }


      kendo.bind(data.sel, App.models.pageView.viewModel);

      // fadeitin
      if (!Utils.isEmpty(data) && !Utils.isEmpty(data.sel)) {
        if ($(data.sel).length) {
          $(data.sel).fadeIn(400);
        }
      }


    } else {
      log('$("#drawer") & "#content-container" not found');
    }// END Drawer
  }, //rightDrawerReady
  leftDrawerReady(data) {
    log("tpl callback - leftDrawer");
    let $drawer = $("#basket");
    let contentContainer_sel = $("#content-container"); // changed this oct 2018 due to @types/kendo-ui in container, below
    if ($drawer.length && $(contentContainer_sel).length) {
      // http://docs.telerik.com/kendo-ui/api/javascript/mobile/ui/drawer#configuration-container
      $drawer.kendoMobileDrawer({
        container: contentContainer_sel,
        position: 'left',
        swipeToOpen: false
      });

      $("#basket-list-touch-scroller").kendoMobileScroller();
      $("#basket-list").kendoMobileListView();

      if ($(".navbar-basket-drawer-btn").length) {
        $(".navbar-basket-drawer-btn").click(function () {
          // console.log("TEST visible", $drawer.data("kendoMobileDrawer"));
          if (($drawer.data("kendoMobileDrawer") as any).visible) { // tslint complaining not found prop?
            $drawer.data("kendoMobileDrawer").hide();
          } else {
            $drawer.data("kendoMobileDrawer").show();
          }
          return false;
        });
      }

      $drawer.find(".close").click(function () {
        $drawer.data("kendoMobileDrawer").hide();
        return false;
      });

    }
  } //leftDrawerReady
};//end CALLBACKS


export class Templates {

  public init() {

    // Start timing now
    time("App.Templates.init");
    //timeEnd("App.Templates.init");

    $(".loader-spinner").each(function (i) {
      $(this).html('<div class="loader-wrap"><span class="k-loading-text">Loading...</span><div class="k-loading-image"/><div class="k-loading-color"/></div></div>');
    });

    if (typeof TemplateLoader === "undefined" || typeof TemplateLoader.loadExtTemplates === "undefined") {
      info("include desertlandscaping.templateLoader.js before using templating system...");
    } else {

      $(document).on("TEMPLATES_LOADED", function (e, aTags) {
        log('%cTEMPLATES_LOADED : [ ' + aTags + ' ]', "color:#999999;");
      });

      //TODO: INSTEAD: get all templates, append to doc, then if el exists do something



      // get the shared templates, if element exists
      let argsMulti = [];
      let args = {};

      //topnav
      let topnav_sel = "#tmpl_inject_topnav";
      if ($(topnav_sel).length) {
        // insert a placeholder?
        //$(topnav_sel).html('<nav class="navbar navbar-default navbar-fixed-top"><div class="container"><div class="navbar-header"><a class="navbar-brand" href="#" title="Loading...">Desert Landscaping</a></div></div></nav>');
        args = {
          path: SiteRoot + "templates/topnav.tmpl.htm",
          tag: "tpl-topnav",
          sel: topnav_sel,
          config: {
            // config object
            emptySelectorFirst: true,
            callback: callbacks.topnavReady
          },
          data: {
            // binding data
            siteRoot: SiteRoot + "#/",
            activeItem: App.currentPage,
            routes: ROUTES
          }
        };
        //this.load(args);
        argsMulti.push(args);
      } // end topnav

      // log(SiteRoot);
      // footer
      let footer_sel = "#tmpl_inject_footer";
      if ($(footer_sel).length) {
        args = {
          path: SiteRoot + "templates/footer.tmpl.htm",
          tag: "tpl-footer",
          sel: footer_sel,
          config: {
            // config object
            emptySelectorFirst: true,
            callback: callbacks.footerReady
          },
          data: {
            // binding data
            siteRoot: SiteRoot,
            routes: ROUTES,
            appVersion: App.VERSION
          }
        };
        //this.load(args);
        argsMulti.push(args);
      } // end footer


      // drawers 
      let drawers_sel = "#tmpl_inject_drawers";
      if ($(drawers_sel).length) {
        // drawers - right
        args = {
          path: SiteRoot + "templates/drawer-right.tmpl.htm",
          tag: "tpl-drawer-right",
          sel: drawers_sel,
          config: {
            // config object
            emptySelectorFirst: false, // append
            keepHidden: true, // allow for the widget to init before showing
            callback: callbacks.rightDrawerReady
          },
          data: {
            // dynamic data
            siteRoot: SiteRoot + "#/",
            activeItem: App.currentPage,
            routes: ROUTES
          }
        };
        //this.load(args);
        argsMulti.push(args);

        // drawers - left
        args = {
          path: SiteRoot + "templates/drawer-left.tmpl.htm",
          tag: "tpl-drawer-left",
          sel: drawers_sel,
          config: {
            // config object
            emptySelectorFirst: false, //append
            keepHidden: true, // allow for the widget to init before showing
            callback: callbacks.leftDrawerReady
          },
          data: {
            // dynamic data
            siteRoot: SiteRoot,
            routes: ROUTES
          }
        };
        //this.load(args);
        argsMulti.push(args);
      } // end drawers


      // Featured Plants
      //moved to funct
      //this.loadFeaturedPlants();


      // main-content-nav
      // var content_nav_sel = "#tmpl_inject_main_content_nav";
      // if ($(content_nav_sel).length) {
      //     args = {
      //         path: SiteRoot + "templates/main-content-nav.tmpl.htm", 
      //         tag: "tpl-main-content-nav", 
      //         sel: content_nav_sel,
      //         config: {
      //             // config object
      //             emptySelectorFirst : true 
      //         },
      //         data: {
      //             // binding data
      //             siteRoot : SiteRoot
      //         }
      //     };
      //     //this.load(args);
      //     argsMulti.push(args);
      // } // end main-content-nav




      //finally
      if (argsMulti.length > 0) {
        this.loadMulti(argsMulti, function () {
          timeEnd("App.Templates.init");
        });
      }
    }//end else
  }// init



  public loadLayout(view, tag, callback, payload?) {
    let doLoad = false,
      argsMulti = [],
      args: any = {
        path: '',//SiteRoot + "templates/featured-plants.tmpl.htm", 
        tag: tag || '',//"tpl-featured-plants", 
        sel: '#tmpl_main_content',
        config: {
          emptySelectorFirst: true,
          callback() {
            info("loadLayout callback:", tag);
          }
        },
        data: {
          // binding data
          siteRoot: SiteRoot,
          routes: ROUTES,
          Utils
        }
      };

    switch (view) {
      case ROUTES.HOME: {
        log("loadLayout: Home");
        args.path = SiteRoot + "templates/layout-home.tmpl.htm";
        if (typeof callback === "function") {
          args.config.callback = callback;
        }
        doLoad = true;
        break;
      }
      case ROUTES.ABOUT: {
        log("loadLayout: About");
        args.path = SiteRoot + "templates/layout-about.tmpl.htm";
        if (typeof callback === "function") {
          args.config.callback = callback;
        }
        doLoad = true;
        break;
      }
      case ROUTES.CONTACT: {
        log("loadLayout: Contact");
        args.path = SiteRoot + "templates/layout-contact.tmpl.htm";
        if (typeof callback === "function") {
          args.config.callback = callback;
        }
        doLoad = true;
        break;
      }
      case ROUTES.IDEAS: {
        log("loadLayout: Ideas");
        args.path = SiteRoot + "templates/layout-ideas.tmpl.htm";
        if (typeof callback === "function") {
          args.config.callback = callback;
        }
        if (typeof payload === "function") {
          args.config.payload = payload;
        }
        doLoad = true;
        break;
      }
      case ROUTES.RESOURCES: {
        log("loadLayout: Resources");
        args.path = SiteRoot + "templates/layout-resources.tmpl.htm";
        if (typeof callback === "function") {
          args.config.callback = callback;
        }
        doLoad = true;
        break;
      }
      case ROUTES.TRIVIA: {
        log("loadLayout: Trivia");
        args.path = SiteRoot + "templates/layout-trivia.tmpl.htm";
        if (typeof callback === "function") {
          args.config.callback = callback;
        }
        doLoad = true;
        break;
      }
      case ROUTES.LEARN: {
        log("loadLayout: Learnmore");
        args.path = SiteRoot + "templates/layout-learnmore.tmpl.htm";
        if (typeof callback === "function") {
          args.config.callback = callback;
        }
        doLoad = true;
        break;
      }
      case ROUTES.BIBLIOGRAPHY: {
        log("loadLayout: Bibliography");
        args.path = SiteRoot + "templates/layout-bibliography.tmpl.htm";
        if (typeof callback === "function") {
          args.config.callback = callback;
        }
        doLoad = true;
        break;
      }
      case ROUTES.ACKNOWLEDGE: {
        log("loadLayout: Acknowledgements");
        args.path = SiteRoot + "templates/layout-acknowledge.tmpl.htm";
        if (typeof callback === "function") {
          args.config.callback = callback;
        }
        doLoad = true;
        break;
      }
      case ROUTES.HISTORY: {
        log("loadLayout: History");
        args.path = SiteRoot + "templates/layout-history.tmpl.htm";
        if (typeof callback === "function") {
          args.config.callback = callback;
        }
        doLoad = true;
        break;
      }
      case ROUTES.TIPS: {
        log("loadLayout: Tips");
        args.path = SiteRoot + "templates/layout-tips.tmpl.htm";
        if (typeof callback === "function") {
          args.config.callback = callback;
        }
        doLoad = true;
        break;
      }
      case ROUTES.PLANT: {
        log("loadLayout: Plant");
        args.path = SiteRoot + "templates/layout-plant.tmpl.htm";
        args.model = payload;
        //args.skipEvt = true;
        if (typeof callback === "function") {
          args.config.callback = callback;
        }
        doLoad = true;
        break;
      }
      case ROUTES.PLANTS: {
        log("loadLayout: Plant Selector", args);
        args.path = SiteRoot + "templates/layout-plant-selector.tmpl.htm";
        args.config.skipRender = true;
        //args.model = payload;
        //args.skipEvt = true;

        doLoad = false;

        argsMulti.push(args);

        
        argsMulti.push({
          path: SiteRoot + "templates/view-plant-selector-list-item.tmpl.htm",
          tag: "tpl-plant-selector-list-item",
          sel: "#plant-selector-listview",
          config: {
            // config object
            emptySelectorFirst: true, //append
            //keepHidden: true, // allow for the widget to init before showing
            skipRender: true//,
            //callback : function(){return true;}
          },
          data: {
            // dynamic data
            siteRoot: SiteRoot,
            routes: ROUTES,
            Utils,
            Config: App.config
          }
          //skipEvt : true
        });

        if (typeof callback !== "function") {
          log("no callback sent");
          callback = function () {
            info("we gots em");
          };
        }

        this.loadMulti(argsMulti, callback);

        break;
      }
    }

    if (doLoad) {
      this.load(args);
    }
  }

  public loadFeaturedAndHomeNav(contentNavSel, featuredSel, callback, cbFeatured) {
    let argsMulti = [],
      args = {};
    //info(contentNavSel, featuredSel);
    featuredSel = featuredSel || "#tmpl_inject_featured_plants";
    if ($(featuredSel).length) {
      args = {
        path: SiteRoot + "templates/featured-plants.tmpl.htm",
        tag: "tpl-featured-plants",
        sel: featuredSel,
        config: {
          emptySelectorFirst: false,
          skipRender: true,
          callback: cbFeatured
        },
        data: {
          // binding data
          siteRoot: SiteRoot,
          routes: ROUTES
        }
      };
      //this.load(args);
      argsMulti.push(args);
    } else {
      info("!featuredSel!", featuredSel);
    }

    // main-content-nav
    contentNavSel = contentNavSel || "#tmpl_inject_main_content_nav";
    if ($(contentNavSel).length) {
      args = {
        path: SiteRoot + "templates/main-content-nav.tmpl.htm",
        tag: "tpl-main-content-nav",
        sel: contentNavSel,
        config: {
          // config object
          emptySelectorFirst: true
        },
        data: {
          // binding data
          siteRoot: SiteRoot,
          routes: ROUTES
        }
      };
      //this.load(args);
      argsMulti.push(args);
    } else {
      info("!contentNavSel!", contentNavSel);
    } // end main-content-nav

    //info(callback);

    //finally
    if (argsMulti.length > 0) {
      this.loadMulti(argsMulti, callback);
    }
  }

  // loadTpl: function (path, tag, sel, doEmpty, doHide, callback) {
  //     if (path && tag && sel) {
  //         var args = {
  //             path: path, 
  //             tag: tag, 
  //             sel: sel,
  //             config: {
  //                 // config object
  //                 emptySelectorFirst : doEmpty, //append
  //                 keepHidden: doHide // allow for the widget to init before showing
  //             },
  //             data: {
  //                 // dynamic data
  //                 callback: callback
  //             }
  //         };
  //         this.load(args);

  //     } else {
  //         info("missing args - can't load tpl...");
  //     }
  // },

  private load(args) {
    /*
    args = {
        path: "templates/drawer-left.tmpl.htm", 
        tag: "tpl-drawer-left", 
        sel: drawers_sel,
        config: {
            // config object
            emptySelectorFirst : false, //append
            keepHidden: true // allow for the widget to init before showing
        },
        data: {
            // dynamic data
            callback: callbacks.leftDrawerReady
        }
    };
    */

    if (!Utils.isEmpty(args) && !Utils.isEmpty(args.path) && !Utils.isEmpty(args.tag) && !Utils.isEmpty(args.sel)) {
      if (Utils.isEmpty(args.config)) {
        args.config = {};
      }
      if (Utils.isEmpty(args.data)) {
        args.data = {};
      }
      
      let callback = null;
      if (!args.skipEvt || args.skipEvt !== true) {
        this.eventListen(args.tag);//, args.sel, args.config);
      } else {
        info("Template !skipEvt.");
        callback = (typeof args.config.callback === 'function') ? args.config.callback : null;
      }

      TemplateLoader.loadExtTemplates({
        path: args.path,//"templates/footer.tmpl.htm", 
        tag: args.tag,//"footer-tpl"
        sel: args.sel,
        config: args.config,
        data: args.data,
        model: args.model
      }, callback);

      


    } else {
      info("Template args not sufficient - doing nothing.");
    }
  } //load

  private loadMulti(args, callback) {

    /*
    args = [{
        path: "templates/drawer-left.tmpl.htm", 
        tag: "tpl-drawer-left", 
        sel: drawers_sel,
        config: {
            // config object
            emptySelectorFirst : false, //append
            keepHidden: true // allow for the widget to init before showing
        },
        data: {
            // dynamic data
            callback: callbacks.leftDrawerReady
        }
    }],
    */
    //info(args);
    if (!Utils.isEmpty(args) && args.length > 0) {
      for (let i = 0; i < args.length; i++) {
        let arg = args[i];

        if (!Utils.isEmpty(arg) && !Utils.isEmpty(arg.path) && !Utils.isEmpty(arg.tag) && !Utils.isEmpty(arg.sel)) {
          if (Utils.isEmpty(arg.config)) {
            arg.config = {};
          }
          if (Utils.isEmpty(arg.data)) {
            arg.data = {};
          }

          args[i] = arg;

          this.eventListen(arg.tag);//, arg.sel, arg.config);

        } else {
          info("Template arg not sufficient - doing nothing. %o", arg);
        }
      }// end for

      TemplateLoader.loadExtTemplates(args, callback);

    }//end not empty args

  } //loadMulti


  private eventListen(tag) { //, this_sel, this_data) {
    let this_tag = "";
    if (!Utils.isEmpty(tag)) {
      this_tag = "." + tag;
    }
    // if (Utils.isEmpty(this_sel)) {
    //     this_sel = "";
    // }
    // if (Utils.isEmpty(this_data)) {
    //     this_data = {};
    // }

    //Subscribe to event triggered when templates loaded
    //(Don't load use templates before they are available)
    $(document).on("TEMPLATE_LOADED" + this_tag, function (e, data) {
      groupCollapsed("TEMPLATE_LOADED" + this_tag);

      if (Utils.isEmpty(data) || Utils.isEmpty(data.tag)) {
        info("TEMPLATE TAG '" + this_tag + "' not found - doing nothing...");
      } else {
        log('%cTemplate loaded : %s (( data: %o', "color:#cccccc;", data.tag, data);

        if (Utils.isEmpty(data.sel)) {
          data.sel = "#selNotFound_ignore";
        }
        if (Utils.isEmpty(data.data)) {
          data.data = {};
        }

        if (!Utils.isEmpty(data.model) || (data.config && data.config.skipRender)) {
          log("skipRender || there's a model here > callback");
          // var view = new kendo.View(tag, {model: data.model, evalTemplate: true});
          // view.render(data.sel);

          if (!Utils.isEmpty(data.config) && !Utils.isEmpty(data.config.emptySelectorFirst) && data.config.emptySelectorFirst === true) {
            if ($(data.sel).length) {
              $(data.sel).find(".loader-wrap").hide();
            }
          }

          //callback
          if (!Utils.isEmpty(data.config)) {
            //log(typeof data.data.callback);
            if (typeof data.config.callback === "function") {
              data.config.callback(data);
            }
          }// end data.config not empty

        } else if ($(data.sel).length) {


          //Compile and cache templates
          let _itemTemplate = kendo.template($("#" + data.tag).html(), { useWithBlock: false });

          // add the Config and Utils to all templates
          data.data.Config = App.config;
          data.data.Utils = Utils;

          //Using the template (assuming "data" is collection loaded elsewhere)
          //_itemTemplate(data);
          //var data = { firstName: "Todd" }; //A value in JavaScript/JSON
          // log(data.data);
          let result = _itemTemplate(data.data);//data); /Pass the data to the compiled template



          $(data.sel).fadeOut(200, function () {
            $(data.sel).find(".loader-wrap").hide();

            // empty : false = append
            if (!Utils.isEmpty(data.config) && !Utils.isEmpty(data.config.emptySelectorFirst) && data.config.emptySelectorFirst === true) {
              // log(data.sel + " - emptySelectorFirst");
              $(data.sel).empty();
            }
            if (!Utils.isEmpty(data.config) && !Utils.isEmpty(data.config.keepHidden) && data.config.keepHidden === true) {
              $(data.sel).append(result);//but keep hidden
            } else {
              $(data.sel).append(result).fadeIn(400, function () {
                log(data.sel + " - done fading in");
                if (!Utils.isEmpty(data.config) && !Utils.isEmpty(data.config.payload)) {
                  if (typeof data.config.payload === "function") {
                    data.config.payload(data);
                  }
                }
              });//fadeIn the result
            }

            //callback
            if (!Utils.isEmpty(data.config)) {
              //info(typeof data.data.callback);
              if (typeof data.config.callback === "function") {
                data.config.callback(data);
              }
            }// end data.config not empty

          });//end fadeout complete

        } else {
          info(data.sel + " not found - doing nothing...");
        }

      } // end data not empty
      groupEnd("TEMPLATE_LOADED" + this_tag);
    });
  } // eventListen
}
